import React from "react";
import { calculateOverdueColor } from "../../../services/helpers";
import OverdueCalculationComponent from "../../../components/OverdueCalculationComponent";
import { InvoiceDetailsModel, InvoiceStatus } from "../../../models/ChasableModels";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

export function StatusChip(props: { status: InvoiceStatus; dueDate: string }) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  if (props.status === InvoiceStatus.PAID) {
    return (
      <Chip
        color="success"
        variant={isDarkMode ? "outlined" : "filled"}
        label={<Typography fontWeight={700}>Paid</Typography>}
      />
    );
  }

  if (props.status === InvoiceStatus.DRAFT) {
    return (
      <Chip
        color="default"
        variant={isDarkMode ? "outlined" : "filled"}
        label={<Typography fontWeight={700}>Draft</Typography>}
      />
    );
  }

  return (
    <Chip
      color={calculateOverdueColor(new Date(props.dueDate))}
      variant={isDarkMode ? "outlined" : "filled"}
      label={<OverdueCalculationComponent dueDate={new Date(props.dueDate)} color="inherit" />}
    />
  );
}
